export const INTL_BANNER_TEXT = [
    "Unlock unlimited styled boxes for a one-off fee",
    " We Ship Internationally",
    "Access monthly limited-edition drops and over 100 global brands",
];
export const UAE_BANNER_TEXT = [
    "Unlock unlimited styled boxes for a one-off 109 AED",
    "3 hour speed style delivery across UAE",
    "Access monthly limited-edition drops and over 100 global brands",
];
